// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kjmu","placeholdersHeader":"styles_placeholdersHeader__1pl9x","editorStyle":"styles_editorStyle__1Nt-A","placeholdersBox":"styles_placeholdersBox__31qs6"};